const MORE_BTN_WIDTH_PX = 36;
const TOOL_GAP_PX = 4;
const DEFAULT_TOOL_SLOT_PX = 36;
export const SPLIT_TOOL_SLOT_PX = 56;

export function estimateToolWidth(toolId: string): number {
  if (toolId === 'Layout') {
    return SPLIT_TOOL_SLOT_PX;
  }
  return DEFAULT_TOOL_SLOT_PX;
}

export function countToolsThatFit(availableWidth: number, toolWidths: number[]): number {
  const total = toolWidths.length;
  if (total === 0 || availableWidth <= 0) {
    return 0;
  }

  const widthIfShown = (count: number, includeMore: boolean) => {
    let width = 0;
    for (let i = 0; i < count; i++) {
      width += toolWidths[i];
      if (i > 0) {
        width += TOOL_GAP_PX;
      }
    }
    if (includeMore) {
      width += (count > 0 ? TOOL_GAP_PX : 0) + MORE_BTN_WIDTH_PX;
    }
    return width;
  };

  if (widthIfShown(total, false) <= availableWidth) {
    return total;
  }

  let visible = 0;
  for (let count = 1; count <= total; count++) {
    if (widthIfShown(count, count < total) <= availableWidth) {
      visible = count;
    } else {
      break;
    }
  }

  return Math.max(1, Math.min(visible, total - 1));
}

export function estimateAvailableToolbarWidth(): number {
  if (typeof window === 'undefined') {
    return 480;
  }
  return Math.max(160, Math.floor(window.innerWidth * 0.5));
}
